import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogModule } from '@angular/material/dialog';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';

@Component({
    selector: 'nio-account-managers-modal',
    templateUrl: './account-managers-modal.component.html',
    styleUrls: ['./account-managers-modal.component.scss'],
    imports: [MatDialogModule, CdkScrollable, CommonModule, MatButtonModule]
})
export class AccountManagersModalComponent {
  constructor(
    public dialogRef: MatDialogRef<AccountManagersModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}
}
